import ListingsRoutingResolver from './ListingRoutingResolver';

class CompaniesListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "company"
    }
}

export default CompaniesListingResolver
